import { render } from "./AddressSearch.vue?vue&type=template&id=235437bb&scoped=true"
import script from "./AddressSearch.vue?vue&type=script&lang=js"
export * from "./AddressSearch.vue?vue&type=script&lang=js"

import "./AddressSearch.vue?vue&type=style&index=0&id=235437bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235437bb"]])

export default __exports__